import { all, fork, spawn, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { sagas as macheteSagas } from 'src/machete-redux';
import designProSagas from 'src/redux/sagas';
import trackError from 'src/lib/rollbar';

export const MAX_REBOOT_ATTEMPTS = 10;

// This catches all uncaught errors within a saga, and then restarts the saga after 100ms.
// There is a maximum number of attempts for each saga (MAX_REBOOT_ATTEMPTS) to prevent infinite loops
export const makeRebootable = (saga) => {
  let attempts = 0;
  return function* rebootableSaga() {
    try {
      yield call(saga);
    } catch (e) {
      trackError(`Saga error: ${e}`);
      yield delay(100);
      attempts += 1;
      if (attempts < MAX_REBOOT_ATTEMPTS) {
        yield call(rebootableSaga);
      }
    }
  };
};

function* sagas() {
  yield all([fork(macheteSagas), fork(designProSagas)]);
}

export default sagas;
